import type { ContentBlock } from "./types";
import type { OnboardingProfile } from "./profile-types";

export function isBlockRelevant(
  block: ContentBlock,
  profile: OnboardingProfile,
): boolean {
  if (!block.showWhen) return true;

  const cond = block.showWhen;

  if (
    cond.ageRange &&
    profile.ageRange &&
    !cond.ageRange.includes(profile.ageRange)
  ) {
    return false;
  }

  if (cond.conditions && cond.conditions.length > 0) {
    const hasOverlap = cond.conditions.some((c) =>
      profile.conditions.includes(c),
    );
    if (!hasOverlap) return false;
  }

  if (
    cond.timeline &&
    profile.timeline &&
    !cond.timeline.includes(profile.timeline)
  ) {
    return false;
  }

  if (
    cond.situation &&
    profile.situation &&
    !cond.situation.includes(profile.situation)
  ) {
    return false;
  }

  if (cond.hasPartner !== undefined) {
    const hasPartner = profile.partnerChoice === "invite";
    if (cond.hasPartner !== hasPartner) return false;
  }

  return true;
}

export function filterBlocks(
  blockList: ContentBlock[],
  profile: OnboardingProfile,
): ContentBlock[] {
  return blockList.filter((b) => isBlockRelevant(b, profile));
}
